import React, { useState } from "react";
import { Table, Button, InputNumber, Popover,Empty,ConfigProvider } from "antd";
import EmptyData from '../Assets/EmptyData.jpg';

const summaryData = [
  { key: '1', sno: '01', fileid: 'KTKKAR0825', monthname: 'JAN 2025', overallweight: '140000', totalldpe: '230', totalhdpe: '23', status: 'Completed' },
  { key: '2', sno: '02', fileid: 'KTKKAR0825', monthname: 'FEB 2025', overallweight: '140000', totalldpe: '300', totalhdpe: '30', status: 'Processed' },
  { key: '6', sno: '06', fileid: 'KTKKAR0825', monthname: 'JUN 2025', overallweight: '140000', totalldpe: '290', totalhdpe: '1000', status: 'Pending PM' }
];

const detailDataInitial = [
  { key: 'd1', mspcname: 'KARWAR', pusthimlldpe: '290 Kg Covers', pusthimlhdpe: '1168 Mother Bags', jaggeryldpe: '290 Kg Covers', jaggeryhdpe: "1168 Mother Bags" },
  { key: 'd2', mspcname: 'KARWAR', pusthimlldpe: '290 Kg Covers', pusthimlhdpe: '1168 Mother Bags', jaggeryldpe: '290 Kg Covers', jaggeryhdpe: "1168 Mother Bags" },
  { key: 'd3', mspcname: 'KARWAR', pusthimlldpe: '290 Kg Covers', pusthimlhdpe: '1168 Mother Bags', jaggeryldpe: '290 Kg Covers', jaggeryhdpe: "1168 Mother Bags" },
  { key: 'd4', mspcname: 'KARWAR', pusthimlldpe: '290 Kg Covers', pusthimlhdpe: '1168 Mother Bags', jaggeryldpe: '290 Kg Covers', jaggeryhdpe: "1168 Mother Bags" },
  { key: 'd5', mspcname: 'KARWAR', pusthimlldpe: '290 Kg Covers', pusthimlhdpe: '1168 Mother Bags', jaggeryldpe: '290 Kg Covers', jaggeryhdpe: "1168 Mother Bags" },
  { key: 'd6', mspcname: 'KARWAR', pusthimlldpe: '290 Kg Covers', pusthimlhdpe: '1168 Mother Bags', jaggeryldpe: '290 Kg Covers', jaggeryhdpe: "1168 Mother Bags" }
];

const CalculationScreen = ({
  detailData,
  editingCell,
  setEditingCell,
  inputValue,
  setInputValue,
  handleCellClick,
  handleSave,
  handleReset,
  handleSavePreview
}) => {
  const editableCell = (text, record, col, label, unit) => {
    const isEditing = editingCell?.key === record.key && editingCell?.col === col;
    return (
      <Popover
        content={
          <div style={{ textAlign: "center", minWidth: 180 }}>
            <h4 style={{ marginBottom: 8, color: "#0066cc" }}>{label}</h4>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 8, gap: 6 }}>
              <Button size="small" onClick={() => setInputValue(val => Math.max(val - 1, 0))}>-</Button>
              <InputNumber value={inputValue} onChange={setInputValue} style={{ width: 80 }} min={0} />
              <Button size="small" onClick={() => setInputValue(val => val + 1)}>+</Button>
              {unit && <span style={{ marginLeft: 4 }}>{unit}</span>}
            </div>
            <Button type="primary" block size="small" onClick={handleSave}>
              Save
            </Button>
          </div>
        }
        trigger="click"
        open={isEditing}
        onOpenChange={open => { if (!open) setEditingCell(null); }}
      >
        <div onClick={() => handleCellClick(record, col)} style={{ cursor: "pointer", minWidth: 60 }}>
          {text}
        </div>
      </Popover>
    );
  };

  return (
    <div style={{ background: "#fafcff", minHeight: "100vh", padding: 24 }}>
      <div style={{ fontSize: "1.25rem", fontWeight: 600, marginBottom: 18 }}>
        KTKKAR0825 &nbsp; JUN 2025
      </div>

      
      <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          background: "#f8f9fb",
          border: "1px solid #e4e7ec",
          borderRadius: 6,
          padding: "12px 0",
          marginBottom: 12,
          fontWeight: 600,
          fontSize:"2 rem"
        }}
      >
        <div style={{ flex: 1, textAlign: "center" }}>MSPC NAME</div>
        <div style={{ flex: 1, textAlign: "center" }}>Project Name</div>
        <div style={{ flex: 1, textAlign: "center" }}>Pushti ML LDPE </div>
        <div style={{ flex: 1, textAlign: "center" }}>Pushti ML HDPE</div>
        <div style={{ flex: 1, textAlign: "center" }}>Jaggery LDPE</div>
        <div style={{ flex: 1, textAlign: "center" }}>Jaggery HDPE</div>
      </div>

      
      {detailData.map((row, idx) => (
        <div
          key={row.key}
          style={{
            display: "flex",
            alignItems: "center",
            background: "#fff",
            border: "1px solid #e4e7ec",
            borderRadius: 10,
            boxShadow: "0 1px 2px #e4e7ec60",
            padding: "12px 0",
            marginBottom: 14,
            fontSize:"1 rem"
          }}
        >
          <div style={{ flex: 1, textAlign: "center", fontWeight: 600}}>
            <span style={{ background: '#888', color: 'white', padding: '6px 16px', borderRadius: '6px' }}>{row.mspcname}</span>
          </div>
          <div style={{ flex: 1, textAlign: "center", fontWeight: 600 }}>ARIDHAL</div>
          <div style={{ flex: 1, textAlign: "center", fontWeight: 600}}>
            {editableCell(row.pusthimlldpe, row, "pusthimlldpe", "Edit PushtiMLLDPE Counts", "Kgs")}
          </div>
          <div style={{ flex: 1, textAlign: "center", fontWeight: 500 }}>
            {editableCell(row.pusthimlhdpe, row, "pusthimlhdpe", "Edit PushtiMLHDPE Counts", "Bags")}
          </div>
          <div style={{ flex: 1, textAlign: "center", fontWeight: 500 }}>
            {editableCell(row.jaggeryldpe, row, "jaggeryldpe", "Edit JaggeryLDPE Counts", "Kgs")}
          </div>
          <div style={{ flex: 1, textAlign: "center", fontWeight: 500 }}>
            {editableCell(row.jaggeryhdpe, row, "jaggeryhdpe", "Edit JaggeryHDPE Counts", "Bags")}
          </div>
        </div>
      ))}

      
      <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 24 }}>
        <Button style={{ backgroundColor: "rgba(85,139,255,1)", color: "#fff" }} onClick={handleReset}>
          RESET to original
        </Button>
        <Button style={{ backgroundColor: "#2aad60", color: "#fff" }} onClick={handleSavePreview}>
          Save & Preview
        </Button>
      </div>
      </div>
    </div>
  );
};



const PreviewScreen = ({ detailData }) => {
  
  const handleExportCSV = () => {
    const columns = [
      "MSPC",
      "Pushti ML LDPE",
      "Pushti ML HDPE",
      "Jaggery LDPE",
      "Jaggery HDPE"
    ];
    const rows = detailData.map(row => [
      row.mspcname,
      row.pusthimlldpe,
      row.pusthimlhdpe,
      row.jaggeryldpe,
      row.jaggeryhdpe
    ]);
    let csv = columns.join(",") + "\n" +
      rows.map(r => r.map(c => `"${c}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "PM_Planning.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{ background: "#f1f5f8", minHeight: "100vh", padding: 24 }}>
      <div style={{ background: "white", borderRadius: 16, padding: 24, marginBottom: 24 }}>
        <div style={{ display: "flex", gap: 32, marginBottom: 24, alignItems: "center" }}>
          <div>
            <div style={{ fontWeight: 600, fontSize: "1.1rem", marginBottom: 4 }}>File Name</div>
            <input style={{ fontWeight:600, borderRadius:5, padding:"2px 12px", background:"#eaf5ff", border:"1px solid #c8e2fa", minWidth:120}} defaultValue="KTKKAR0825" readOnly />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: "1.1rem", marginBottom: 4 }}>Month</div>
            <input style={{ fontWeight:600, borderRadius:5, padding:"2px 12px", background:"#eaf5ff", border:"1px solid #c8e2fa", minWidth:120}} defaultValue="Aug 2025" readOnly />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: "1.1rem", marginBottom: 4 }}>Total Ben.</div>
            <input style={{ fontWeight:600, borderRadius:5, padding:"2px 12px", background:"#eaf5ff", border:"1px solid #c8e2fa", minWidth:120}} defaultValue="1234567" readOnly />
          </div>
          <Button style={{ marginLeft: "auto", background: "#8244db", color: "#fff", fontSize: 16 }} onClick={handleExportCSV}>Export</Button>
        </div>
        
        <div style={{ display: "flex", gap: 20, marginBottom: 30 }}>
          <div style={{ background: "#edf1f8", padding: 18, borderRadius: 12, minWidth: 150, textAlign: "center", fontWeight: 600 }}>
            TOTAL MSPC<br /><span style={{ fontSize: 30, color: "#3089d9" }}>149</span>
          </div>
          <div style={{ background: "#edf1f8", padding: 18, borderRadius: 12, minWidth: 150, textAlign: "center", fontWeight: 600 }}>
            TOTAL Projects<br /><span style={{ fontSize: 30, color: "#3089d9" }}>1490</span>
          </div>
          <div style={{ background: "#edf1f8", padding: 18, borderRadius: 12, minWidth: 150, textAlign: "center", fontWeight: 600 }}>
            Total Category<br /><span style={{ fontSize: 30, color: "#3089d9" }}>6</span>
          </div>
          <div style={{ background: "#edf1f8", padding: 18, borderRadius: 12, minWidth: 150, textAlign: "center", fontWeight: 600 }}>
            Overall FG<br /><span style={{ fontSize: 30, color: "#3089d9" }}>2900 T</span>
          </div>
        </div>
        
        <div style={{ display: "flex", gap: 15, marginBottom: 30 }}>
          {[
            { label: "Pushthi", value: "100 T" },
            { label: "MLC", value: "2.3 T" },
            { label: "MLM", value: "2.9 T" },
            { label: "UPC", value: "20 T" },
            { label: "UPM", value: "23 T" },
            { label: "ANC", value: "123 T" },
            { label: "ANM", value: "98 T" }
          ].map((cat) => (
            <div key={cat.label} style={{
              background: "#eaf1fa", padding: "12px 20px", borderRadius: 8, minWidth: 89, textAlign: "center", fontWeight: 500,
              border: "1px solid #c2d6e7"
            }}>
              {cat.label}<br /><span style={{ fontWeight: 600, color: "#3585fa", fontSize: "1rem" }}>{cat.value}</span>
            </div>
          ))}
        </div>
        
        <Table
          columns={[
            { title: "MSPC", dataIndex: "mspcname", key: "mspcname",
              render: () => <span style={{ background: '#D6FFDF', color: 'dark', padding: '6px 20px', borderRadius: '6px', fontWeight: 600 }}>KARWAR</span> },
            { title: "Pushti ML LDPE", dataIndex: "pusthimlldpe", key: "pusthimlldpe" },
            { title: "Pushti ML HDPE", dataIndex: "pusthimlhdpe", key: "pusthimlhdpe" },
            { title: "Jaggery LDPE", dataIndex: "jaggeryldpe", key: "jaggeryldpe" },
            { title: "OVERALL LDPE", key: "overallldpe",
              render: () => <span style={{ background: '#D6FFDF', color: 'dark', fontWeight:600, padding: '6px 24px', borderRadius: '8px' }}>13.39 T</span>
            },
            { title: "OVERALL HDPE", key: "overallhdpe",
              render: () => <span style={{ background: '#D6FFDF', color: 'dark', fontWeight:600, padding: '6px 24px', borderRadius: '8px' }}>3000 Bags</span>
            }
          ]}
          dataSource={detailData}
          pagination={false}
          bordered
          style={{ marginBottom: 24 }}
        />
        {/* Bottom Button */}
        <div style={{ textAlign: "center", marginTop:12 }}>
          <Button style={{
            background: "#25b86a",
            color: "#fff",
            fontWeight: 600,
            padding: "10px 48px",
            fontSize: "1.2rem",
            borderRadius:12,
            boxShadow:"0px 4px 24px #e2f9ec"
          }}>Submit For Approval</Button>
        </div>
      </div>
    </div>
  );
};


const PM_Planning = () => {
  const [detailData, setDetailData] = useState(detailDataInitial);
  const [editingCell, setEditingCell] = useState(null);
  const [inputValue, setInputValue] = useState(0);
  const [screen, setScreen] = useState("summary"); 

  
  const handleCellClick = (record, col) => {
    let value = 0;
    if (record[col] && typeof record[col] === "string") {
      const match = record[col].match(/\d+/);
      value = match ? parseInt(match, 10) : 0;
    } else if (!isNaN(Number(record[col]))) {
      value = Number(record[col]);
    }
    setEditingCell({ key: record.key, col });
    setInputValue(value);
  };

  const handleSave = () => {
    setDetailData(prev =>
      prev.map(row =>
        row.key === editingCell.key
          ? {
              ...row,
              [editingCell.col]:
                (editingCell.col.toLowerCase().includes("hdpe") &&
                  !editingCell.col.toLowerCase().includes("ldpe"))
                  ? inputValue + " Mother Bags"
                  : inputValue + " Kg Covers"
            }
          : row
      )
    );
    setEditingCell(null);
    setInputValue(0);
  };

  const handleReset = () => setDetailData(detailDataInitial);

  
  const handleCalculate = () => setScreen("calculate");
  const handleSavePreview = () => setScreen("preview");

  
  const summaryColumns = [
    { title: 'S.no', dataIndex: 'sno', key: 'sno' },
    { title: 'File ID', dataIndex: 'fileid', key: 'fileid' },
    { title: 'Month Name', dataIndex: 'monthname', key: 'monthname' },
    { title: 'Overall Weight', dataIndex: 'overallweight', key: 'overallweight' },
    { title: 'Tot.LDPE', dataIndex: 'totalldpe', key: 'totalldpe' },
    { title: 'Tot.HDPE', dataIndex: 'totalhdpe', key: 'totalhdpe' },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        if (status === "Completed") return <span style={{ background: "#3585fa", color: "#e6fbf0", borderRadius: 5, fontWeight: 500, padding: "1px 18px" }}>Completed</span>;
        if (status === "Pending PM") return <span style={{ background: "orange", color: "black", borderRadius: 5, fontWeight: 500, padding: "1px 14px" }}>Pending PM</span>;
        if (status === "Processed") return <span style={{ background: "#f2f2fa", color: "#37bf4d", borderRadius: 20, fontWeight: 500, fontSize: 13, padding: "1px 15px", minWidth: 90, display: "inline-block", textAlign: "center" }}>Processed</span>;
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) =>
        record.status === "Pending PM"
          ? <Button style={{ background: "#2aad60", color: "#fff" }} onClick={handleCalculate}>Calculate</Button>
          : record.status === "Completed"
            ? <Button>Print File</Button>
            : record.status === "Processed"
              ? <Button>Preview</Button>
              : null
    }
  ];

  
  if (screen === "calculate") {
    return (
      <CalculationScreen
        detailData={detailData}
        editingCell={editingCell}
        setEditingCell={setEditingCell}
        inputValue={inputValue}
        setInputValue={setInputValue}
        handleCellClick={handleCellClick}
        handleSave={handleSave}
        handleReset={handleReset}
        handleSavePreview={handleSavePreview}
      />
    );
  }
  if (screen === "preview") {
    return <PreviewScreen detailData={detailData} />;
  }

  
  return (
    <div>
      <ConfigProvider
                    renderEmpty={() => (
                      <Empty
                        image={EmptyData}
                        description="No CategoryMaster Data Available"
                        imageStyle={{ height: 200 }}
                      />
                    )}
                  >
      <Table
        columns={summaryColumns}
        dataSource={summaryData}
        pagination={false}
        size="small"
        bordered
      />
      </ConfigProvider>
    </div>
  );
};

export default PM_Planning;
